import React, {useState, useEffect} from 'react';
import Vimeo from '@u-wave/react-vimeo';
import ReactPlayer from 'react-player';
import { Dialog } from 'primereact/dialog';
import ReactHtmlParser from 'react-html-parser';

function Reproductor({urlData, texto}) {
    const [visible, setVisible] = useState(false);
    const [dimensions, setDimensions] = useState({ 
        alto: window.innerHeight,
        ancho: window.innerWidth
      })
    
    const verFinal = () => {
        if(texto!=='' || texto!=='<p></p>'){
            setVisible(true)
        }
    }

    useEffect(() => {
        function handleResize() {
          setDimensions({
            alto: window.innerHeight,
            ancho: window.innerWidth
          })
        
        }
    
        window.addEventListener('resize', handleResize)
    
        return _ => {
          window.removeEventListener('resize', handleResize)
        
    }},[])

    const verReproductor = () => {
        if(urlData.includes('vimeo')){
            return <Vimeo video={urlData} width={dimensions.ancho} height={dimensions.alto}
            onEnd={()=>verFinal()} 
            />
        }else{
            return <ReactPlayer 
            url={urlData} width={dimensions.ancho+'px'} height={dimensions.alto+'px'}
            onEnded={()=>verFinal()} />
        }
    }

  return (
    <div className='d-flex justify-content-center'>
        {verReproductor()}
        <Dialog visible={visible} modal={false} onHide={() => setVisible(false)} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
           {ReactHtmlParser(texto)}
        </Dialog>
    </div>
  );
}

export default Reproductor;
